<template>
  <router-view v-if="!userStore.isLoading || userStore.isAuthenticated" />
  <Loading v-else />
  <DDynamicDialog class="bg-surface-800" />
  <DConfirmDialog />
  <Toast />
</template>

<script setup>
import Toast from '@/components/misc/Toast.vue';
import { useUserStore } from '@/stores/userStore';
import Loading from '@/views/Loading.vue';
import { DConfirmDialog, DDynamicDialog } from '@disguise/cloud-ui';

const userStore = useUserStore();
</script>
